import { faCheckCircle } from "@fortawesome/pro-light-svg-icons/faCheckCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import React, { useEffect, useState } from "react";

export function DefaultBackground(props) {
    const onClick = (item) => {
        props.onClick(item)
    }
    const current = props.current || null
    const bgList = [
        'img/backgrounds/background1.jpg',
        'img/backgrounds/background2.jpg',
        'img/backgrounds/background3.jpg',
        'img/backgrounds/background4.jpg',
        'img/backgrounds/background5.jpg',
        'img/backgrounds/background6.jpg',
        'img/backgrounds/background7.jpg',
        'img/backgrounds/background8.jpg',
        'img/backgrounds/background9.jpg',
        'img/backgrounds/background10.jpg',
        'img/backgrounds/background11.jpg',
        'img/backgrounds/background12.jpg',
    ]
    return (
        <div className="tw-flex tw-flex-wrap">
            {bgList.map((url) => (
                <div key={url} className="tw-w-1/3 tw-h-28 tw-bg-cover tw-flex tw-group" style={{ backgroundImage: "url(/" + url + ")" }}>
                    {current && current === url &&
                        <div className="tw-transition tw-bg-black/60 tw-text-white tw-flex tw-w-full tw-h-full tw-justify-center tw-items-center">
                            <FontAwesomeIcon size="lg" icon={faCheckCircle} />
                        </div>}
                    {current !== url &&
                        <div onClick={() => onClick(url)} className="tw-opacity-0 tw-transition group-hover:tw-opacity-100 tw-bg-black/70 tw-text-white tw-cursor-pointer tw-flex tw-w-full tw-h-full tw-justify-center tw-items-center">
                            {t('generic.use-image')}
                        </div>
                    }
                </div>
            ))}
        </div>
    )
}